import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  soList: [],
  loading: false,
  error: null,
};

const soSlice = createSlice({
  name: "GetSO",
  initialState,
  reducers: {
    fetchSOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchSOSuccess: (state, action) => {
      state.loading = false;
      state.soList = action.payload;
    },

    fetchSOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSOStart,
  fetchSOSuccess,
  fetchSOFailure,
} = soSlice.actions;

export default soSlice.reducer;